import React, { forwardRef } from 'react';
import "./Checkbox.css";

const Checkbox = forwardRef((props, ref) => {
  
  return <input
      type="checkbox"
      className='checkbox_input'
      {...props}
      ref={ref}
      checked={props.value}
    />
})
export default Checkbox;